// Angular dependencies.
import {
    NgModule,
    Component,
    OnInit
} from '@angular/core';

import {
    RouterModule,
    Routes,
    Router,
    ActivatedRoute
} from '@angular/router';

import * as Screeps from '@screeps/map';

import { AuthModule } from '../auth.module';
import { AuthGuard } from '../auth.module/auth.guard';

import { BaseComponent } from './base';

import { UserResolver } from '../shared-services.module/user.resolver';
import { WorldMapSizeResolver } from './world-map-size.resolver';
import { WorldMapStartRoomResolver } from './world-map-start-room.resolver';
import { WorldMapStatusResolver } from './world-map-status.resolver';


@Component({
    selector: 'app-noop-component',
    template: '<div>Noop</div>'
})
export class NoopComponent implements OnInit {
    constructor(
        private _router: Router,
        private _route: ActivatedRoute
    ) {
    }

    async ngOnInit() {
        const data = this._route.snapshot.data['worldStartRoom'];

        let shard, room;
        try {
            [, shard, room] = data[0].match(/^(.*)\/(.*)$/);
        } catch (err) {
            shard = 'shard0';
        }

        const point: [number, number] = Screeps.getPointByRoomName(room).map((v: number) => v + .5);

        // TODO: Refact After full transition from angularjs to angular
        const navigate = async () => {
            const navigateSuccess = await this._router.navigate([shard], {
                queryParams: {
                    pos: point.join(',')
                },

                relativeTo: this._route
            });

            if (!navigateSuccess) {
                navigate();
            }
        };

        navigate();
    }
}

const routes: Routes = [{
    path: 'map2',
    canActivate: [AuthGuard],
    resolve: {
        user: UserResolver,
        worldStartRoom: WorldMapStartRoomResolver
    },
    children: [{
        path: '',
        component: NoopComponent,
    }, {
        path: ':shard',
        component: BaseComponent,
        resolve: {
            size: WorldMapSizeResolver,
            status: WorldMapStatusResolver
        }
    }]
}];

@NgModule({
    imports: [
        AuthModule,
        RouterModule.forRoot(routes)
    ],
    declarations: [
        NoopComponent
    ],
    exports: [
        RouterModule
    ],
    providers: [
        UserResolver,
        WorldMapSizeResolver,
        WorldMapStartRoomResolver,
        WorldMapStatusResolver
    ]
})
export class WorldMapRouting { }
